import React from 'react';
import styled from 'styled-components';
import BrandComponent from '../components/brand';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 90dvh;
  background-color: #f9fafb;
  padding: 1rem;
  box-sizing: border-box;

  @media(max-width:991px){
    justify-content: flex-start;
  }
`;

const Box = styled.div`
  
`;

export default function HomePage() {
    return (
        <Wrapper>
            <Box>
                <BrandComponent />
            </Box>
        </Wrapper>
    );
}